jQuery(document).ready(function ($) {
  if (document.querySelector("engraving-personalizer")) {
    return;
  }

  let plugin_status = $.trim($(".show-caption-status").text());
  if (plugin_status == false) {
    // Do nothing , return false is not accepted by shopify;
  } else {
    console.log("Captions plugin: Trying to enable side-fields captions");

    var runicMap = {
      a: "&#5800;",
      b: "&#5842;",
      c: "&#5810;",
      d: "&#5854;",
      e: "&#5846;",
      f: "&#5843;",
      g: "&#5815;",
      h: "&#5819;",
      i: "&#5825;",
      j: "&#5827;",
      k: "&#5810;",
      l: "&#5850;",
      m: "&#5847;",
      n: "&#5822;",
      o: "&#5855;",
      p: "&#5832;",
      q: "&#5810;",
      r: "&#5809;",
      s: "&#5834;",
      t: "&#5839;",
      u: "&#5794;",
      v: "&#5817;",
      w: "&#5817;",
      x: "&#5798;",
      y: "&#5831;",
      z: "&#5833;",
    };

    String.prototype.replaceWithRune = function (find) {
      var replaceString = this;
      for (var i = 0; i < find.length; i++) {
        if (runicMap[find[i]] != undefined) {
          replaceString = replaceString.replace(find[i], runicMap[find[i]]);
        } // else skip.
      }
      return replaceString;
    };

    $("input[type=text]", $(".product-form__line-item-property"))
      .not(":last")
      .attr("maxlength", 14)
      .attr("placeholder", "TAP to ADD custom text: Max 14 symbols");

    var configContainer = $("input[name='properties[Custom Config]']");

    let targets = $(".product-form__line-item-property").not(":last");
    let targetImageWrap = $(".product__media-image-wrapper img");
    targetImageWrap.wrap($("<div/>").addClass("side-captions-wrapper"));
    let captionsWrapper = $(".side-captions-wrapper");
    let captionEthalon = $("<div/>")
      .addClass("side-caption-layer")
      .append($("<div/>").addClass("internal-text"));
    let selectedData = {};

    $.each(targets, function (key, element) {
      let sourceElement = $(element);
      let elName = $("input", sourceElement).attr("name");
      const classSuffix = elName
        .replace("[", "-")
        .replace("]", "")
        .replace(" ", "-")
        .trim();
      let className = ".side-caption-" + classSuffix;

      // Orientation fieldset.
      sourceElement.append(
        $(
          '<fieldset class="options-fieldset bottom-left-rounded"><p class="fieldset-label">Orientation</p>' +
            '<label for="orientation-horizontal" class="options-title">' +
            '<input type="radio" class="or-option or-horizontal" name="orientation-' +
            classSuffix +
            '" id="orientation-horizontal-' +
            classSuffix +
            '" value="horisonal" checked="checked" />Horizontal</label>' +
            '<label for="orientation-vertical" class="options-title">' +
            '<input type="radio" class="or-option or-vertical" name="orientation-' +
            classSuffix +
            '" id="orientation-vertical-' +
            classSuffix +
            '" value="vertical" />Vertical</label>' +
            "</fieldset>"
        )
      );

      // Letters type.
      sourceElement.append(
        $(
          '<fieldset class="options-fieldset bottom-right-rounded">' +
            '<p class="fieldset-label">Letters type</p>' +
            '<label for="letters-type-latin" class="options-title">' +
            '<input type="radio" class="type-option input-type-latin" name="letters-type-' +
            classSuffix +
            '" id="letters-type-' +
            classSuffix +
            '" value="latin" checked="checked" />' +
            "Latin" +
            "</label>" +
            '<label for="letters-type-runic" class="options-title">' +
            '<input type="radio" class="type-option input-type-runic" name="letters-type-' +
            classSuffix +
            '" id="letters-type-' +
            classSuffix +
            '" value="runic" />' +
            "Runic" +
            "</label>" +
            "</fieldset>"
        )
      );

      sourceElement.show();
      let local_caption = captionEthalon.clone();

      local_caption.addClass("side-caption-" + classSuffix);
      captionsWrapper.append(local_caption);

      // Binding the events.
      $(".or-horizontal", sourceElement).click(function ($e) {
        if ($(this).is(":checked")) {
          console.log("horizontal", className);
          let captionTarget = $(className);
          $("input[type=text]", sourceElement)
            .attr("maxlength", "14")
            .attr("placeholder", "TAP to ADD custom text: Max 14 symbols");
          captionTarget.removeClass("vertical-updown");
        }
      });

      $(".or-vertical", sourceElement).click(function ($e) {
        if ($(this).is(":checked")) {
          console.log("vertical", className);
          let captionTarget = $(className);
          $("input[type=text]", sourceElement)
            .attr("maxlength", "10")
            .attr("placeholder", "TAP to ADD custom text: Max 10 symbols");
          captionTarget.addClass("vertical-updown");
          let sourceInput = $("input", sourceElement);
          let inputValue = sourceInput.val();
          if (inputValue.length > 10) {
            sourceInput.val(inputValue.substring(0, 10));
          }
        }
      });

      $("input[type=radio]", sourceElement).click(function ($e) {
        if ($(this).is(":checked")) {
          sourceElement.keyup();
        }
      });

      sourceElement.keyup(function ($e) {
        let sourceInput = $("input", sourceElement);
        let inputValue = sourceInput.val();
        let targetValue;
        // Extract the class name.
        let inputName = sourceInput.attr("name");
        let classSuffix = inputName
          .replace("[", "-")
          .replace("]", "")
          .replace(" ", "-")
          .trim();
        let className = ".side-caption-" + classSuffix;
        let captionTarget = $(className);
        let textPlaceholder = $(className + " .internal-text");

        if (
          $(".input-type-runic", sourceElement).is(":checked") &&
          $("input[type=text]", $(this)).val().length > 0
        ) {
          //let input_low = inputValue.toLowerCase();
          //let runicValue = input_low.replaceWithRune(input_low);
          targetValue = inputValue;
          captionTarget
            .addClass("side-caption-runic")
            .removeClass("side-caption-latin");
          $("input[type=text]", $(this))
            .addClass("side-caption-runic")
            .removeClass("side-caption-latin");
        } else {
          targetValue = inputValue;
          captionTarget
            .removeClass("side-caption-runic")
            .addClass("side-caption-latin");
          $("input[type=text]", $(this))
            .removeClass("side-caption-runic")
            .addClass("side-caption-latin");
        }
        // textPlaceholder.text("").append(targetValue);
        selectedData[classSuffix] = {
          text: targetValue,
          type: $(".type-option:checked", sourceElement).val(),
          orientation: $(".or-option:checked", sourceElement).val(),
        };
        let dataString = JSON.stringify(selectedData);
        configContainer.attr("value", dataString).text(dataString);
        // console.log(configContainer);
      });
    });

    // Activate spoiler.
    /*
    $("input[type=text],fieldset", $(".product-form__line-item-property")).css({
      display: "none",
    }); */
    $("label", $(".product-form__line-item-property")).click(function () {
      $(this).next("input").slideToggle(500);
      $(this).parent().find("fieldset").slideToggle(500);
    });
  }
});
